
        import * as module0 from './controllers/recipe_controller.js';import * as module1 from './controllers/search_controller.js'
        const modules = {
            "./controllers/recipe_controller.js": module0,
            "./controllers/search_controller.js": module1,
        };
        export default modules;
      